/**
 * Generato automaticamente.
 * framework-cmp-procedimenti
 */
import { useQuery } from 'react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { apiClientRequest } from '../../../client/apiClient';
import type { ErrorType } from '../../../client/apiClient';
import type { StatoComunicazioneDTO } from '.././schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * Ottiene l'elenco degli stati di comunicazione
 * @summary Elenco Stati Comunicazione
 */
export const getBackStatiComunicazione = (
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<StatoComunicazioneDTO[]>(
    {
      url: `/framework-bo-procedimenti/stati-comunicazione`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackStatiComunicazioneQueryKey = () =>
  [`/framework-bo-procedimenti/stati-comunicazione`] as const;

export const getGetBackStatiComunicazioneQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackStatiComunicazione>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getBackStatiComunicazione>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryOptions<
  Awaited<ReturnType<typeof getBackStatiComunicazione>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBackStatiComunicazioneQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackStatiComunicazione>>
  > = ({ signal }) => getBackStatiComunicazione(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetBackStatiComunicazioneQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackStatiComunicazione>>
>;
export type GetBackStatiComunicazioneQueryError = ErrorType<unknown>;

/**
 * @summary Elenco Stati Comunicazione
 */
export const useGetBackStatiComunicazione = <
  TData = Awaited<ReturnType<typeof getBackStatiComunicazione>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getBackStatiComunicazione>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackStatiComunicazioneQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
